import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { buildRouter } from '@/router'
import '@payopera/chat-widget/styles.css'
import App from './App.vue'

const app = createApp(App)

app.use(createPinia())
app.use(buildRouter())

app.mount('#app')
